import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const LoaderComponent: React.FC<{}> = (props) => {
  return <Spin indicator={antIcon} {...props} />;
};

LoaderComponent.defaultProps = {
  type: 'TailSpin',
  color: '#9a9a9a',
  width: 22,
  height: 22,
};

export default LoaderComponent;
